import { node, string } from 'prop-types';
import clsx from 'clsx';

import AppBar from 'components/AppBar';
import { useStyles } from './styles';
import { useMediaQuery } from '@mui/material';
import Sidebar from 'components/Sidebar';
import { sections } from 'components/Sidebar/items';
import { useLayout } from 'core/contexts/layout';

const Layout = ({ children, contentClassName, isHome = false }) => {
    const { open } = useLayout();
    const classes = useStyles();

    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
    const drawerWidth = isMobile ? '100vw' : 240;

    const contentShiftStyles = open
        ? {
              transition: (theme) =>
                  theme.transitions.create('margin', {
                      easing: theme.transitions.easing.easeOut,
                      duration: theme.transitions.duration.enteringScreen,
                  }),
              marginLeft: drawerWidth,
              maxHeight: '100vh',
              maxWidth: '100vw',
              overflow: 'hidden',
          }
        : {};

    return (
        <>
            <AppBar open={open} isHome={isHome} />
            <Sidebar sections={sections} />
            <main
                // style={{ marginTop: '56px' }}
                className={clsx(classes.content, contentClassName)}
                style={contentShiftStyles}
            >
                {children}
            </main>
        </>
    );
};

Layout.propTypes = {
    children: node.isRequired,
    contentClassName: string,
};

Layout.displayName = 'Layout';

export default Layout;
